var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrderBy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  fillRule: "evenodd",
  d: "M13.646 9.646 11.5 11.793V2.955c0-.251-.224-.455-.5-.455s-.5.204-.5.455v8.838L8.354 9.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708M8.354 6.354a.5.5 0 0 1-.708 0L5.5 4.207v8.839c0 .25-.224.454-.5.454s-.5-.203-.5-.454V4.207L2.354 6.354a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708",
  clipRule: "evenodd"
})));
export default SvgOrderBy;